// API Configuration
// Automatically detects environment and uses appropriate URL

const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:5000/api'  // Development
  : 'https://data.usehypwave.com/api';  // Production

/** Uploaded By filter sentinel for Hypwave client-demand records */
export const HYPWAVE_TOOL_UPLOADER_ID = '__hypwave_tool__';

// Manual override (uncomment to force a specific environment):
// export const API_BASE_URL = 'http://localhost:5000/api';  // Force development
// export const API_BASE_URL = 'https://data.usehypwave.com/api';  // Force production
